import * as NavigationMenu from '@radix-ui/react-navigation-menu'

import { cn } from '@/legacy-src/lib/utils'

import { HeaderNavigationProvider, type HeaderNavigationProviderProps } from './HeaderNavigationItem.context'

export interface HeaderNavigationItemProps
  extends NavigationMenu.NavigationMenuItemProps,
    Pick<HeaderNavigationProviderProps, 'trigger'> {}

export const HeaderNavigationItem = ({ trigger, ...props }: HeaderNavigationItemProps) => {
  return (
    <HeaderNavigationProvider trigger={trigger}>
      <NavigationMenu.Item {...props} className={cn('list-none', props.className)} />
    </HeaderNavigationProvider>
  )
}
